var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    username: "tina@haiku.ai",
    uuid: "cc628224-92a6-4d0d-9dc3-fe0f89e7254b",
    organization: "Tina",
    project: "LearnPage",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/LearnPage",
    version: "0.0.5",
    root: "https://cdn.haiku.ai/7ccc2013-ef9a-4bd4-bc8c-0eed8a54e5d2/50f3dd5aa4acacabe79e12bf8506a9ce1918629a/",
    core: "4.5.0",
    title: "Scribble",
    type: "haiku",
    relpath: "code/scribble/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {
    "haiku:Scribble-faa2b40b6ef909a1": {},
    "haiku:Hand2-Copy-d9d38a6f939b06b8": {},
    "haiku:Path-10-5bae576acdfe96d7": {}
  },
  timelines: {
    Default: {
      "haiku:Hand2-Copy-d9d38a6f939b06b8": {
        "style.margin": "0",
        "sizeAbsolute.y": 239,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 294,
        "sizeMode.x": 1,
        "style.position": "absolute",
        "sizeMode.y": 1,
        "translation.x": {
          "1467": { value: 410.59, edited: true, curve: "easeInOutQuad" },
          "0": { value: 479.17999999999995, edited: true },
          "533": { value: 435.18, edited: true, curve: "easeInOutQuad" },
          "667": { value: 454.18, edited: true, curve: "easeInOutQuad" },
          "1200": { value: 392.59, edited: true, curve: "easeInOutQuad" },
          "117": {
            value: 479.17999999999995,
            edited: true,
            curve: "easeInOutQuad"
          },
          "2000": { value: 343.14, edited: true, curve: "easeInOutQuad" },
          "2217": { value: 345.14, edited: true, curve: "easeInOutQuad" },
          "2633": { value: 283.18, edited: true, curve: "easeInOutQuad" },
          "3000": { value: 269.14, edited: true, curve: "easeInOutQuad" },
          "3167": { value: 258.1400146484375, edited: true }
        },
        "translation.y": {
          "1467": { value: 263, edited: true, curve: "linear" },
          "0": { value: 143.5, edited: true },
          "533": { value: 175, edited: true, curve: "linear" },
          "667": { value: 184, edited: true, curve: "linear" },
          "1200": { value: 230.5, edited: true, curve: "linear" },
          "117": { value: 143.5, edited: true, curve: "linear" },
          "2000": { value: 281.5, edited: true, curve: "linear" },
          "2217": { value: 314.5, edited: true, curve: "linear" },
          "2633": { value: 316.5, edited: true, curve: "linear" },
          "3000": { value: 350, edited: true, curve: "linear" },
          "3167": { value: 497.4, edited: true }
        },
        "style.zIndex": 2,
        "scale.x": {
          "0": { value: 1, edited: true },
          "2917": { value: 1, edited: true, curve: "easeInOutQuad" },
          "3000": { value: 1.2, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "2917": { value: 1, edited: true, curve: "easeInOutQuad" },
          "3000": { value: 1.2, edited: true }
        }
      },
      "haiku:Hand2-Copy-ed8767bef176941c": {
        "translation.x": 586,
        "translation.y": 92
      },
      "haiku:Page-1-b23c101117471dbd": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      },
      "haiku:Path-10-2ddfc6bfc795b35b": {
        d:
          "M5,214.168586 C9.47530441,197.768109 14.3336474,173.329147 32.2603352,166.707631 C50.1870229,160.086116 67.4564032,193.973336 79.4801236,179.244169 C91.503844,164.515002 69.2200426,147.934605 85.7321776,134.866361 C102.244313,121.798117 127.640132,151.533713 142.530773,138.692514 C157.421414,125.851316 117.979481,106.111842 130.255127,85.7673356 C142.530773,65.4228289 176.426669,65.4228289 187.179389,54.6330381 C197.93211,43.8432472 170.441857,42.6684197 175.369598,29.3126303 C178.654758,20.4087707 195.531559,12.3045606 226,5",
        stroke: { "0": { value: "#EF33F8", edited: true } },
        strokeWidth: 9,
        strokeDasharray: { "0": { value: 450, edited: true } },
        strokeDashoffset: {
          "0": { value: -450, edited: true, curve: "linear" },
          "3000": { value: 0, edited: true }
        }
      },
      "haiku:Scribble-faa2b40b6ef909a1": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 479.18,
        "sizeAbsolute.y": 350,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Page-1-b21723f0d6fafc87": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-7d95c94307764741": {
        "translation.x": -586,
        "translation.y": -110
      },
      "haiku:Path-10-5bae576acdfe96d7": {
        "sizeAbsolute.y": 219,
        "sizeMode.x": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 231,
        "style.margin": "0",
        "style.position": "absolute",
        "sizeMode.y": 1,
        "translation.x": 226.73,
        "translation.y": 143.5,
        "style.zIndex": 1,
        opacity: {
          "0": { value: 1, edited: true },
          "3167": { value: 1, edited: true, curve: "easeInOutQuad" },
          "3333": { value: 0, edited: true }
        }
      },
      "haiku:Hand2-339c00eae1634c6f": {
        "translation.x": 10.187023,
        "translation.y": 18.041958
      },
      "haiku:Path-7-b6da8fc7bf05a91b": {
        d:
          "M43.070761,22.2517483 L19.3773171,23.5371098 C16.1466243,23.6521348 13.53429,24.1139469 11.5403141,24.922546 C9.5463383,25.731145 7.79327415,27.0395937 6.2811217,28.847892 L0.619722461,37.743024 C-0.679693256,40.2898051 0.0643233443,41.5631957 2.85177226,41.5631957 C5.63922118,41.5631957 7.56528621,41.0154938 8.62996735,39.9200901 C11.5375776,35.7323222 15.2591001,33.0215024 19.7945349,31.7876309 C24.3299697,30.5537593 29.0921118,29.9368235 34.0809612,29.9368235 C29.1114958,31.1706951 25.4701584,32.7378852 23.156949,34.6383939 C20.8437396,36.5389025 18.823377,42.204826 17.0958611,51.6361643 C16.5143886,55.3019181 17.1093564,57.3613513 18.8807646,57.8144642 C20.6521727,58.267577 22.0775675,57.1720984 23.156949,54.5280285 L31.8279532,41.1205843 L48.4343097,39.9200901 L43.070761,22.2517483 Z",
        fill: "#FA9E92"
      },
      "haiku:Path-5-5afa1a8979124504": {
        d:
          "M283.758623,176.146436 L283.758623,238.958042 C173.565355,161.473222 112.38906,116.922985 100.229739,105.307331 C88.0704177,93.6916759 79.5150559,86.9093111 74.5636533,84.9602361 C63.5724495,80.915726 55.1287733,77.082847 49.2326249,73.4615991 C43.3364765,69.8403511 38.3100944,65.4003005 34.1534786,60.1414472 L39.4883224,39.8551695 C42.2141343,38.5215542 43.5770402,36.203494 43.5770402,32.900989 C43.5770402,27.9472315 42.8391405,27.515133 38.5407431,23.0141272 C35.6751448,20.0134566 32.2735814,17.9892827 28.3360529,16.9416055 C26.6379222,17.9122816 25.0322134,19.0759099 23.5189263,20.4324907 C21.2489956,22.4673618 20.3863868,23.7377954 18.4087315,24.5052667 C16.4310761,25.272738 12.6510849,25.039073 10.2778518,24.1809199 C7.9046188,23.3227668 8.27746016,21.6286276 8.70640553,21.0305591 C9.13535089,20.4324907 11.1463003,19.982757 13.1617126,17.9089251 C15.177125,15.8350931 17.1040959,12.9432974 17.1813753,12.8469149 C20.404532,8.82700584 20.6072294,7.18619047 23.1884374,4.31651297 C25.8315331,1.37803124 25.7028038,0.687112677 28.3360529,0.111821423 C30.0915523,-0.27170608 32.0306942,0.331339528 34.1534786,1.92095825 C36.3854968,2.72404167 39.2542555,4.32357966 42.7597547,6.71957222 C48.0180035,10.3135611 49.9031245,10.9544595 52.691478,11.6457133 C55.4798315,12.3369671 58.3249854,12.3369671 61.5311712,13.8156213 C64.737357,15.2942755 65.4368041,18.6297745 72.620611,34.2491852 C79.8044179,49.8685959 81.3837026,52.4680937 84.4990633,55.7914872 C87.6144239,59.1148808 90.6595484,56.9626805 94.3528447,58.9185871 C98.0461409,60.8744936 97.8216352,63.6601428 120.7514,77.7500242 C136.03791,87.1432784 190.373651,119.942083 283.758623,176.146436 Z",
        fill: "#FDCEC9"
      },
      "haiku:Path-6-d1e14ee8a3f13c1d": {
        d:
          "M33.9630967,59.9745056 L13.6330939,47.0757842 C11.8737317,45.9676502 10.6963157,44.8834667 10.1008458,43.8232336 C9.505376,42.7630006 9.3181752,41.4174863 9.53924346,39.7866906 C9.91364505,37.6547395 9.75256756,36.1647692 9.05601099,35.3167796 C6.85339893,33.2665231 6.08572192,30.7671808 6.00089686,29.064517 C5.91607181,27.3618532 6.41928098,25.2769175 9.53924346,24.7354073 C11.6192184,24.3744004 13.6198625,25.2654903 15.5411757,27.4086769 C17.8100904,30.0591508 20.3634225,32.5789896 23.2011719,34.9681934 C27.457796,38.551999 28.3879047,39.2788162 32.6723031,40.2024418 C35.5285687,40.8181922 38.3351939,40.338471 41.0921787,38.7632784 L36.8418644,63.4206293 L33.9630967,59.9745056 Z",
        fill: "#FDCEC9"
      },
      "haiku:Pencil2-d1cfe6e4fed31ee3": {
        "translation.x": 72.666313,
        "translation.y": 94.829918,
        "rotation.z": 3.804818
      },
      "haiku:Rectangle-e62cb651a30297e1": {
        d:
          "M35.2855206,-17.3239136 L46.1037449,-17.3090082 L46.213857,62.4245479 C46.2175179,65.0755122 44.0714546,67.2275111 41.4204903,67.2311721 C41.4160762,67.2311782 41.4116621,67.2311782 41.4072481,67.2311721 L40.1890512,67.2294937 C37.5432568,67.2258483 35.3993231,65.0819214 35.3956692,62.436127 L35.3301046,14.9599238 L35.2855206,-17.3239136 Z",
        fill: "#212D31",
        "translation.x": 46.143799,
        "translation.y": -22.523991,
        "rotation.z": 1.134464
      },
      "haiku:Path-4-8ad622a37c21adc6": {
        d:
          "M81.24931,11.9533464 L76.7022901,2.16705007 L87.7496512,0.334251823 C89.9841158,-0.197971658 91.2851662,-0.0946073553 91.6528025,0.644344732 C92.0204387,1.38329682 91.5420085,2.39246784 90.2175119,3.67185779 L81.24931,11.9533464 Z",
        fill: "#EF33F8"
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Scribble-faa2b40b6ef909a1",
      "haiku-title": "Scribble"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-10-5bae576acdfe96d7",
          "haiku-title": "Path 10",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/Path 10.svg#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-b23c101117471dbd", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "Path-10-2ddfc6bfc795b35b",
                  id: "Path-10"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Hand2-Copy-d9d38a6f939b06b8",
          "haiku-title": "hand2 copy",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/hand2 copy.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-b21723f0d6fafc87", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-7d95c94307764741",
                  id: "Artboard"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "Hand2-Copy-ed8767bef176941c",
                      id: "hand2-copy"
                    },
                    children: [
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "Hand2-339c00eae1634c6f",
                          id: "hand2"
                        },
                        children: [
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-7-b6da8fc7bf05a91b",
                              id: "Path-7"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-5-5afa1a8979124504",
                              id: "Path-5"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-6-d1e14ee8a3f13c1d",
                              id: "Path-6"
                            },
                            children: []
                          }
                        ]
                      },
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "Pencil2-d1cfe6e4fed31ee3",
                          id: "pencil2"
                        },
                        children: [
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Rectangle-e62cb651a30297e1",
                              id: "Rectangle"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-4-8ad622a37c21adc6",
                              id: "Path-4"
                            },
                            children: []
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-learnpage/code/scribble/code.js
// module id = 467
// module chunks = 127651196306611